import { render, staticRenderFns } from "./CheckoutUserAddresses.vue?vue&type=template&id=4dbde868&"
import script from "./CheckoutUserAddresses.vue?vue&type=script&lang=js&"
export * from "./CheckoutUserAddresses.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutUserAddresses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports